import styled from 'styled-components';

export const TableWrapper = styled.div`
    position: relative;
    height: 600px;
    width: 100%;
    overflow-x: scroll;
    overflow-y: scroll;

    @media (max-width: 1200px) {
        height: 400px;
    }
`;